import { useEffect, useState } from "react"
import {
  InboxContextQueryHookResult,
  useInboxContextQuery
} from "@pathwright/graphql-client/src/generated"

type Inbox = {
  id: number | "*"
  type: "inbox" | "cohort" | "group"
  meta: {
    title: string
    subtitle?: string | null
  }
}

export const getInboxFromQueryResponse = (
  data: NonNullable<InboxContextQueryHookResult["data"]>
): Inbox => {
  if (
    data.inboxContext &&
    "cohort" in data.inboxContext &&
    data.inboxContext.cohort
  ) {
    const { cohort } = data.inboxContext

    return {
      id: cohort.id,
      type: "cohort",
      meta: {
        title: cohort.resource?.name || "",
        subtitle: cohort.name
      }
    }
  } else if (
    data.inboxContext &&
    "group" in data.inboxContext &&
    data.inboxContext.group
  ) {
    const { group } = data.inboxContext
    return {
      id: group.id!,
      type: "group",
      meta: {
        title: group.name || ""
      }
    }
  } else {
    return {
      id: "*",
      type: "inbox",
      meta: {
        title: "Inbox"
      }
    }
  }
}

const useInboxContext = ({
  cohort_id,
  group_id
}: {
  cohort_id?: number | null
  group_id?: number | null
}) => {
  let [inbox, setInbox] = useState<Inbox | undefined>()

  const { data, loading, error } = useInboxContextQuery({
    // no-cache is required here otherwhise we never get a data update for some reason
    // oh?, well... let's at least try cache-and-network.
    fetchPolicy: "cache-and-network",
    variables: { cohort_id, group_id }
  })

  useEffect(() => {
    if (data && data.inboxContext) {
      setInbox(getInboxFromQueryResponse(data))
    }
  }, [data])

  return { inbox, loading, error }
}

export default useInboxContext
